import React from "react";
import styles from "./Loginpage.module.scss";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { TextField } from "@mui/material";

import Button from "@mui/material/Button";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import key from "../../icons/key.svg";
import profile from "../../icons/profile.svg";

import { Formik } from "formik";
import { IconButton, InputAdornment } from "@mui/material";
import { validationSchema } from "../Schemas/Schemas";
import { useNavigate } from "react-router-dom";
import logo from "../../icons/firstocklogo.svg";
import image from "../../images/image.svg";
import hand from "../../icons/hand.svg";
import { firstTimeUserAPICall, loginAPICall } from "../../Shared/APIcalls";
import { IToken } from "../../Shared/dtos";

export default function LoginPage() {
  //   const navigate = useNavigate();
  //   const pathname = useLocation;
  //   const handleNavigate = (data: any) => {
  //     navigate(data);
  //   };
  const navigate = useNavigate();
  const [showAccountNumber, setShowAccountNumber] = React.useState(false);

  const handleClickShowAccountNumber = () =>
    setShowAccountNumber((show) => !show);

  const handleMouseDownAccountNumber = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const initialValues = {
    userId: "",

    password: "",
    dateOfBirth: "",
  };
  const handleSubmitForm = (values: any) => {
    let obj: any = {
      username: values.userId.trim().toUpperCase(),
      password: values.password.trim(),
      client_id: values.dateOfBirth.trim().toUpperCase(),
    };

    loginAPICall(obj)
      .then((response: any) => {
        console.log("response", response);
        sessionStorage.setItem("token", response.data.accessToken);
        sessionStorage.setItem("tokenType", response.data.tokenType);
        sessionStorage.setItem("userID", values.userId.toUpperCase());

        firstTimeUserAPICall()
          .then((response: any) => {
            navigate("/dashboard");
          })
          .catch((error: any) => {});
      })
      .catch((error: any) => {
        console.log("errordata", error);
        const errorObj: any = {
          "Incorrect username or password": "Invalid User Details",
        };
        window.alert(
          errorObj[error.response.data.detail] ?? error.response.data.detail
        );
      });
  };

  return (
    <div className={styles.main}>
      <div className={styles.mainwrapper}>
        <div className={styles.changing}>
          <div>
            <img
              src={logo}
              alt=""
              style={{ width: "100px", cursor:'pointer' }}
              onClick={() => {
                navigate("/");
              }}
            />
            <p className={styles.heading}>
              Login to Firstock
              <span>
                <img src={hand} alt="hand" style={{ width: "30px" }} />
              </span>
            </p>
          </div>

          <div className={styles.userid}>
            <div>
              <Formik
                validationSchema={validationSchema}
                initialValues={initialValues}
                onSubmit={(values: any) => {
                  // console.log("values", values);
                  handleSubmitForm(values);
                  //   navigate("/page3");
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => {
                  // const isEmailFilled = values.email.trim()! == "";
                  // const isPasswordFilled = values.password.trim()! == "";
                  // const isFormValid = isEmailFilled && isPasswordFilled;
                  // console.log("errors", errors);
                  // console.log("values", values);
                  return (
                    <>
                      <form noValidate onSubmit={handleSubmit}>
                        <div>
                          <p className={styles.smallheading}>User ID</p>
                          <div className={styles.TextField}>
                            <TextField
                              fullWidth
                              sx={{
                                margin: "5px 0px",
                                "& fieldset": { border: "none" },
                                background: "rgba(246, 246, 251, 1)",
                                borderRadius: "10px",
                              }}
                              name="userId"
                              id="userId"
                              placeholder="Eg SR3249"
                              value={values.userId.toUpperCase()}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              //   inputProps={{
                              //     maxLength: 50,
                              //   }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <img
                                      src={profile}
                                      alt="profile"
                                      style={{ width: "20px" }}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                              error={touched.userId && Boolean(errors.userId)}
                              helperText={
                                touched.userId && errors.userId?.toString()
                              }
                            />
                          </div>

                          <p className={styles.smallheading}>Password</p>
                          <div className={styles.TextField}>
                            <TextField
                              sx={{
                                margin: "5px 0px",

                                "& fieldset": { border: "none" },
                                background: "rgba(246, 246, 251, 1)",
                                borderRadius: "10px",
                              }}
                              fullWidth
                              autoComplete="off"
                              name="password"
                              id="password"
                              type={showAccountNumber ? "text" : "password"}
                              placeholder="Eg xxxxxxxxxx"
                              value={values.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={
                                touched.password && Boolean(errors.password)
                              }
                              helperText={
                                touched.password && errors.password?.toString()
                              }
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton
                                      onClick={handleClickShowAccountNumber}
                                      onMouseDown={handleMouseDownAccountNumber}
                                      edge="end"
                                    >
                                      {showAccountNumber ? (
                                        <VisibilityIcon
                                          style={{ width: "20px" }}
                                          sx={{
                                            color: "#7868df",
                                          }}
                                        />
                                      ) : (
                                        <VisibilityOffIcon
                                          style={{ width: "20px" }}
                                          sx={{
                                            color: "#7868df",
                                          }}
                                        />
                                      )}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <img
                                      src={key}
                                      alt="key"
                                      style={{ width: "20px" }}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </div>
                          <p className={styles.smallheading}>DOB/PAN</p>
                          <div className={styles.TextField}>
                            <TextField
                              fullWidth
                              sx={{
                                margin: "5px 0px",
                                "& fieldset": { border: "none" },
                                background: "rgba(246, 246, 251, 1)",
                                borderRadius: "10px",
                              }}
                              name="dateOfBirth"
                              id="dateOfBirth"
                              placeholder="Eg DDMMYYYY"
                              value={values.dateOfBirth.toUpperCase()}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              //   inputProps={{
                              //     maxLength: 50,
                              //   }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <CalendarMonthIcon
                                      sx={{
                                        color: "rgba(183, 173, 248, 1)",
                                        height: "40px",
                                      }}
                                    />
                                  </InputAdornment>
                                ),
                              }}
                              error={
                                touched.dateOfBirth &&
                                Boolean(errors.dateOfBirth)
                              }
                              helperText={
                                touched.dateOfBirth &&
                                errors.dateOfBirth?.toString()
                              }
                            />
                          </div>

                          <div>
                            <Button
                              onClick={() => {
                                // handleNavigate("");
                              }}
                              type="submit"
                              //   fullWidth
                              variant="contained"
                              sx={{
                                borderRadius: "50px",

                                mt: 3,
                                mb: 2,
                                margin: "10px 0px 10px 0",
                                padding: "10px 80px",
                                backgroundColor: "rgba(109, 0, 255, 1)",
                                "&:hover": {
                                  backgroundColor: "rgba(109, 0, 255, 1)",
                                },
                              }}
                              disabled={
                                values.dateOfBirth &&
                                values.password &&
                                !errors.dateOfBirth
                                  ? false
                                  : true
                              }
                            >
                              <span
                                style={{
                                  textTransform: "none",
                                }}
                              >
                                Login
                              </span>
                            </Button>
                          </div>
                          <div>
                            <p style={{ fontSize: "12px" }}>
                              Don’t have an account?
                              <span
                                style={{
                                  color: "rgba(109, 0, 255, 1)",
                                  marginLeft: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  window.open(
                                    "https://signup.thefirstock.com/",
                                    "_blank"
                                  );
                                }}
                              >
                                Sign-up now
                              </span>
                            </p>
                          </div>
                        </div>
                      </form>
                    </>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
        <div className={styles.image}>
          <img className={styles.imageclass} src={image} alt="image" />
        </div>
      </div>
    </div>
  );
}
